module.exports = __webpack_public_path__ + "static/media/alert.e74d4c45.svg";